
import {
  defineComponent,
} from 'vue';
import { useRouter } from 'vue-router';
import {
  Form, Select, Switch, Input, Rate, Slider, Button, Row, Col, Spin,
} from 'ant-design-vue';
import UploadImg from '@/components/UploadImg.vue';
import asynButtonVue from '@/components/asynButton.vue';
import {
  BasicInfo, BasicInfoController, caseModules, caseUnits, caseUnitFormatter,
} from './basicInfo';

export default defineComponent({
  name: 'BasicInfo',
  data() {
    return {
      labelCol: {
        span: 4,
      },
      wrapperCol: {
        span: 20,
      },
    };
  },
  components: {
    aForm: Form,
    aFormItem: Form.Item,
    aSelect: Select,
    aSelectOption: Select.Option,
    aSwitch: Switch,
    aTextarea: Input.TextArea,
    aInput: Input,
    aRate: Rate,
    aSlider: Slider,
    aButton: asynButtonVue,
    aSpin: Spin,
    Row,
    Col,
    UploadImg,
  },
  setup(props, { emit }) {
    const router = useRouter();
    const basicInfo = new BasicInfo(router.currentRoute.value.params.caseId as string);
    const basicInfoController = new BasicInfoController(basicInfo, emit);
    return {
      basicInfo,
      basicInfoController,
      caseModules,
      caseUnits,
      caseUnitFormatter,
    };
  },
});
